import { createUseStyles } from 'react-jss'
import { colors, sizes } from '../../variables.style'

export const style = {
  label: {
    color: 'white',
    backgroundColor: colors.brandDark,
    borderRadius: 4,
    border: `1px solid ${colors.brandDark}`,
    cursor: 'pointer',
    maxWidth: 200,
    height: sizes.buttonHeight,
    display: 'flex',
    padding: '6px 15px',
    fontFamily: 'Arial, sans-serif',
    alignItems: 'center',
    '&:hover, &:focus, &.active': {
      backgroundColor: 'white',
      color: colors.brandDark
    },
    '&::before': {
      fontSize: 14,
      marginRight: 5
    }
  },
  text: {
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis'
  },
  input: {
    width: 0.1,
    height: 0.1,
    opacity: 0,
    overflow: 'hidden'
  },
  uploadIcon: {
    marginRight: '5px'
  }
}

export const useStyles = createUseStyles(style)
